<template>
    <div class="conditions-label cursor-pointer">
        <a :class="labelColor" class="d-flex flex-nowrap align-center gc-1" @click.prevent="showConditions">
            <v-icon size="x-small" class="">mdi-information-outline</v-icon>
            <span class="text-caption">{{ label }}</span>
        </a>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import {ConditionsLabel} from '~src/components/snippets/conditionsLabel.src'
    import {EventBus, SHOW_CONDITIONS_MODAL_EVENT} from '@/utils/event-bus'

    @Component({})
    export class CancelPenaltyLabel extends ConditionsLabel {
        @Prop({default: () => []}) cancelPenalty
        @Prop({default: false}) xSmall
        @Prop({default: true}) small

        async load() {}

        showConditions() {
            EventBus.$emit(SHOW_CONDITIONS_MODAL_EVENT, {offerKey: null, conditionsInfo: this.conditionsInfo})
        }

        get isLoading() {
            return false
        }

        get conditionsInfo() {
            //Map for compatibility with ConditionsModal and ConditionsLabel
            return {
                cancellationItems: this.cancelPenalty
                    .map(cancelPenaltyItem => ({
                        dateFrom: cancelPenaltyItem.startDateTime,
                        dateTo: cancelPenaltyItem.endDateTime,
                        description: cancelPenaltyItem.description,
                        price: {
                            currency: cancelPenaltyItem.currency,
                            amount: cancelPenaltyItem.amount,
                        },
                        noShow: cancelPenaltyItem.noShow,
                    }))
                    .sort((a, b) =>
                        this.$dateFns.compareAsc(this.$dateFns.parseISO(a.dateFrom), this.$dateFns.parseISO(b.dateFrom))
                    ),
            }
        }
    }

    export default CancelPenaltyLabel
</script>

<style scoped>
    small {
        min-height: 44px;
        max-width: 120px;
    }
    .conditions-label {
        line-height: 1;
    }
</style>
